module.exports = __webpack_public_path__ + "static/media/coinsW.a5cf0c60.png";